import { ValueGetterParams } from "ag-grid-community";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { get } from "lodash";

export const STORE_WITH_UNITS = ({ getterParams }) => {
    const { api, column }: ValueGetterParams = getterParams;
    const doorsWithUnits = new Set();

    const colType = getterParams.column.getColDef().type as ColumnTypes;
    if (colType === ColumnTypes.DoorBulkQuantity) {
        let hasColAnyUnit = false;
        api.forEachNodeAfterFilter((rowNode) => {
            const value = api.getValue(column, rowNode) ?? 0;
            if (value > 0) {
                hasColAnyUnit = true;
            }
        });
        return hasColAnyUnit ? 1 : "";
    }

    api.forEachNodeAfterFilter((rowNode) => {
        const doorSet = get(rowNode, ["data", "_doorsWithUnits", column.getColId()], []);
        doorSet.forEach((doorId) => doorsWithUnits.add(doorId));
    });

    if (doorsWithUnits.size === 0) {
        return "";
    }

    return doorsWithUnits.size;
};
